import { render, staticRenderFns } from "./BankSetting.vue?vue&type=template&id=9908ca2a&scoped=true&"
import script from "./BankSetting.vue?vue&type=script&lang=js&"
export * from "./BankSetting.vue?vue&type=script&lang=js&"
import style0 from "./BankSetting.vue?vue&type=style&index=0&id=9908ca2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9908ca2a",
  null
  
)

export default component.exports